<div mat-dialog-content>
  <p>{{data.summary}}</p>
</div>
<div mat-dialog-actions>
<button mat-button mat-dialog-close>Close</button>
</div>
